module.exports = __webpack_public_path__ + "385560c50e79819627356a5f3ef76832.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/icons/HTML.png
// module id = oWl/
// module chunks = 22